<template>
  <div>
    <l-geo-json :geojson="radarLine" :options="options" pane="radarPane" />
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>
import { LGeoJson } from "vue2-leaflet";
import Color from "../../../scss/color.scss";

/**
 * 川の防災情報 地図画面 レーダラインレイヤー
 * RadarLineLayer.vue
 * @author LIS
 */
export default {
  name: "radar-line-layer",
  components: {
    LGeoJson
  },
  /** 算出部 */
  computed: {
    /** 地図設定情報 */
    mapConfig: {
      get() {
        return this.$store.state.map.mapConfig;
      }
    },
    /** レーダ雨量の種類の取得 */
    radarType: {
      get() {
        return this.$store.state.radar.radarType;
      }
    },
    /** XRAIN定量範囲、Cバンド定量範囲のライン */
    radarLine: {
      get() {
        if (this.radarType === "xrain") {
          return this.$store.state.radar.xrainLine;
        } else {
          return this.$store.state.radar.cbandLine;
        }
      }
    },
    /** ラインの透過設定 */
    radarLineOpacity: {
      get() {
        // 不透明度に反転して、パーセント指定を少数に変換して返す
        return (100 - this.$store.state.radar.radarOpacity) * 0.01;
      }
    },
    /** XRAIN定量範囲、Cバンド定量範囲のラインの表示設定 */
    options: {
      get() {
        if (this.radarLineOpacity >= 0) {
          return {
            style: () => {
              let rLOption = {
                color: Color.radarLine,
                weight: this.mapConfig.radarLine.weight,
                opacity: this.radarLineOpacity
              };
              return rLOption;
            }
          };
        }
        return null;
      }
    }
  }
};
</script>
